import { Component, Input, OnInit } from '@angular/core';
import { NgClass, DatePipe } from "@angular/common";

@Component({
  selector: 'app-rating-bar',
  standalone: true,
  imports: [    NgClass,],
  templateUrl: './rating-bar.component.html',
  styleUrl: './rating-bar.component.scss'
})
export class RatingBarComponent implements OnInit  {
  @Input() ratings = [1,2,3,4,5];
  @Input() selectedRate: number = 3;

  ngOnInit() {
  }
}
